import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Notification',
  path: '/homenet/noti',
  redirect: '/homenet/noti/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),

  children: [
    {
      name: 'Notification List',
      path: 'list',
      meta: {
        label: 'Notification List'
      },
      component: lazyLoading('homenet/NotiList')
    },
    {
      name: 'Latest Notification',
      path: 'latest',
      meta: {
        label: 'Latest Notification'
      },
      component: lazyLoading('homenet/NotiLatest')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/noti.js